export enum CollectionShowOnPage {
  Wines = 'wines',
  Wineries = 'wineries',
  ToDo = 'todo'
}
